module.exports = __webpack_public_path__ + "images/e7ac570ada0eedd822a6b7a6e7d96b1e.svg";